import "./detailsOfPackage.css";
import Arrow from "../images/Arrow.png";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import rtlPlugin from "stylis-plugin-rtl";
import { CssBaseline } from "@mui/material";
import createCache from "@emotion/cache";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";
import {
  Button,
} from "@mui/material";
import React, { useRef, useState, useEffect, useContext } from "react";
import LocationSearchInput from "./reactAutoComplete";
import MultiSteps from "./MultiSteps/MultiSteps";
import { useMediaQuery } from "react-responsive";
import { DataContext } from "../../../dataContext";
import moment from "moment";
import { useParams } from "react-router-dom";
import Select from "react-select";

export default function DetailsOfPackage({ showSteps, setShowSteps }) {
  const { t } = useTranslation();
  const { token } = useParams();
  const pickUpOptions = [
    { value: "1", label: t("COLLECTION_OPTION1") },
    { value: "2", label: t("COLLECTION_OPTION2") },
    { value: "3", label: t("COLLECTION_OPTION3") },
    { value: "4", label: t("COLLECTION_OPTION4") },
  ];
  const deliveryOptions = [
    { value: "1", label: t("DELIVERY_OPTION1") },
    { value: "2", label: t("DELIVERY_OPTION2") },
    { value: "3", label: t("DELIVERY_OPTION3") },
    { value: "4", label: t("DELIVERY_OPTION4") },
  ];
  const {
    responseGetById,
    setResponseGetById,
    exitAddress,
    setExitaddress,
    errorAutoComplet,
    setErrorAutoComplet,
    getDataFromServer,
    setGetDataFromServer,
    errorDDline,
    setErrorDDline,
    errorPickUp,
    setErrorPickUp,
    address,
    setAddress,
    detailsOfPackage,
    setDetailsOfPackage,
    time,
    setTime,
    nameAndPhone,
    setNameAndPhone,
    checkboxValue,
    setCheckboxValue,
    activeStep,
    setActiveStep,
  } = useContext(DataContext);

  const now = new Date();
  now.setMinutes(now.getMinutes() + 1 - now.getTimezoneOffset());
  const ddL = new Date();
  ddL.setHours(ddL.getHours() + 15);

  const ref = useRef();
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 650px)" });
  const Tablet = useMediaQuery({ query: "(max-width: 800px)" });

  useEffect(() => {
    if (token && !responseGetById) {
      console.log(showSteps);
      // console.log('f');
      setShowSteps(true);
    }
  }, []);

  const ltrTheme =
    document.documentElement.dir === "rtl"
      ? createTheme({ direction: "rtl" })
      : createTheme({ direction: "ltr" });

  const cacheLtr = createCache({
    key: "muiltr",
  });
  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [rtlPlugin],
  });
  console.log("language: " + ltrTheme.direction);

  const InputLabelProps = {
    fontFamily: "Heebo",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "22px",
    textAlign: "right",
    color: "#4F5976",
  };

  const startSteps = (e) => {
    e.preventDefault();
    // console.log(exitAddress);
    if (
      exitAddress.cityName == "" &&
      exitAddress.streetName == "" &&
      exitAddress.streetNum == ""
    ) {
      return setErrorAutoComplet(t("ERROR_MESSAGE_AUTOCOMPLET"));
    }

    if (!errorAutoComplet) {
      setShowSteps(true);
    }
  };

  const focusClearErrors = () => {
    setErrorPickUp(false);
    setErrorDDline(false);
    setErrorAutoComplet(false);
  };
  //const [value, setValue] = (useState < Dayjs) | (null > dayjs());
  //const [value, setValue] = (React.useState < Dayjs) | (null > dayjs());
  // const [valuee, setValuee] =
  //   (React.useState < Dayjs) | (null > dayjs("2018-01-01T00:00:00.000Z"));

  const changeListPickUp = (e) => {
    if (e !== "") {
      time.pickUpTime = e.value;
    }
  };
  const changeListDelivery = (e) => {
    if (e !== "") {
      time.ddLine = e.value;
    }
  };

  const changePickUpTime = (e) => {
    if (isTabletOrMobile) {
      //old code - without date poup in desktop
      if (e.target.value !== "") {
        time.pickUpTime = e.target.value;
        time.ddLine = moment(new Date(time.pickUpTime))
          .add(1, "days")
          .format("YYYY-MM-DD[T]HH:mm");
        setTime({ ...time });
      } else {
        time.pickUpTime = now.toISOString().substring(0, 16);
        time.ddLine = moment().add(1, "days").format("YYYY-MM-DD[T]HH:mm");
        setTime({ ...time });
      }
    } else {
      console.log(e);
      console.log(e["$d"]);
      if (e["$d"] !== "") {
        time.pickUpTime = moment(new Date(e["$d"])).format(
          "YYYY-MM-DD[T]HH:mm"
        );
        time.ddLine = moment(new Date(time.pickUpTime))
          .add(1, "days")
          .format("YYYY-MM-DD[T]HH:mm");
        setTime({ ...time });
        console.log(time);
      } else {
        time.pickUpTime = now.toISOString().substring(0, 16);
        time.ddLine = moment().add(1, "days").format("YYYY-MM-DD[T]HH:mm");
        setTime({ ...time });
      }
    }
  };
  const checkOnFocus = (e) => {
    time.pickUpTime != e.target.value && setErrorPickUp("");
    setErrorDDline("");
  };

  const changeDdLine = (e) => {
    if (isTabletOrMobile) {
      // old
      time.ddLine = e.target.value;
      setTime({ ...time });
    } else {
      time.ddLine = moment(new Date(e["$d"])).format("YYYY-MM-DD[T]HH:mm");
      console.log(e);
      console.log(time.ddLine);
      setTime({ ...time });
    }
  };

  let height;

  function styleHeight() {
    height = "";
    if (isMobile) {
      if (errorAutoComplet || errorDDline || errorPickUp) {
        return (height += "600px");
      }
    }
  }

  const heightDetails = () => {
    let heightDetails = "";
    if (isMobile && showSteps && activeStep < 5) {
      return (heightDetails = "821px");
    }
    if (isMobile && activeStep == 5) {
      return (heightDetails = "745px");
    }
    if (isMobile && !showSteps) {
      return (heightDetails = "531px");
    }
    if (isTabletOrMobile && showSteps && activeStep < 5) {
      return (heightDetails = "686px");
    }

    if (isTabletOrMobile && activeStep == 5) {
      return (heightDetails = "585px");
    }
    if (isTabletOrMobile && !showSteps) {
      return (heightDetails = "645px");
    }
    if ((Tablet && !showSteps) || (activeStep == 5 && Tablet)) {
      return (heightDetails = "592px");
    }
    if (Tablet && showSteps) {
      return (heightDetails = "675px");
    } else {
      return (heightDetails = "809px");
    }
  };

  const switchPaddingLefInput = () => {
    if (ltrTheme.direction === "rtl" && isMobile) {
      return "25px";
    }
  };

  return (
    <section
      className="container-fluid mobile_details_height"
      style={{ height: heightDetails(), background: !showSteps && "#F1F1F6" }}
    >
      <div className="cover">
        <div className="coverDetails" style={{ height: styleHeight() }}>
          {" "}
          {!showSteps ? (
            <div style={{ position: "relative" }}>
              <div className="details mobile_details">
                <div
                  style={{
                    margin: "auto",
                    width: "100%",
                    height: "60px",
                  }}
                >
                  <div style={{ width: "20%", padding: "5px", float: "left" }}>
                    <img
                      style={{ width: "180%" }}
                      alt="pogo חברת שליחויות"
                      src="data:image/png;base64,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"
                    ></img>
                  </div>{" "}
                  <div
                    style={{
                      width: "65%",
                      float: "right",
                      padding: "5px 10px",
                      textalign: "right",
                      fontsize: "18px",
                      fontweight: "600",
                      direction: "rtl",
                      marginleft: "25px",
                    }}
                  >
                    מבית{" "}
                    <i>
                      <a
                        href="https://connect.getpogo.app/"
                        style={{
                          fontsize: "150%",
                          color: "#470be8",
                          fontweight: "900",
                          fontstretch: "expanded",
                        }}
                      >
                        פוגו חיבורים - שליחות מהיום להיום
                      </a>
                    </i>
                    <br />
                    <div style={{ fontSize: "10px" }}>
                      שלחו לנו את פרטי המשלוח ואנחנו מחברים לכם שליח
                    </div>
                  </div>
                </div>
                <div className="flex_header_details">
                  <h1 className="h1_mobile">
                    {" "}
                    {t("DETAILS_OF_PACKAGE_LINE_1")}{" "}
                  </h1>
                  <p className="p_details_mobile">
                    {t("DETAILS_OF_PACKAGE_LINE_2")}
                  </p>{" "}
                </div>{" "}
                <div className="mobile_width_detailofpackage">
                  <Stack onFocus={focusClearErrors}>
                    <div
                      style={{
                        marginBottom: isMobile && "0px",
                        height: isTabletOrMobile && !isMobile && "111px",
                      }}
                    >
                      <LocationSearchInput
                        errorAutoComplet={errorAutoComplet}
                        setErrorAutoComplet={setErrorAutoComplet}
                        exitAddress={exitAddress}
                        setExitaddress={setExitaddress}
                        label={t("DETAILS_OF_PACKAGE_INPUT_ADDRESS")}
                        value={address}
                        onChange={(address) => setAddress(address)}
                      />{" "}
                    </div>
                    {isTabletOrMobile ? (
                      <div
                        className="flex_date_time"
                        style={{
                          visibility: isTabletOrMobile ? "visible" : "hidden",
                          display: isTabletOrMobile ? "block" : "flex",
                          marginTop: isMobile
                            ? "60px"
                            : isTabletOrMobile
                            ? "0px"
                            : "60px",
                          marginBottom: isMobile
                            ? "45px"
                            : isTabletOrMobile
                            ? "0px"
                            : "65px",
                        }}
                      >
                        <CacheProvider
                          value={
                            // old - before calendar
                            ltrTheme.direction === "rtr" ? cacheRtl : cacheLtr
                          }
                        >
                          <CssBaseline /> {/* old - before calendar */}{" "}
                          <Select
                            options={pickUpOptions}
                            type="select-pickup"
                            placeholder={t("DETAILS_OF_PACKAGE_INPUT_DATE")}
                            defaultValue={pickUpOptions[0].label}
                            onChange={changeListPickUp}
                            inputProps={{
                              style: {
                                direction: "rtl",
                                textAlign:
                                  ltrTheme.direction === "rtl"
                                    ? "right"
                                    : "left",
                                display:
                                  ltrTheme.direction === "rtl"
                                    ? "flex"
                                    : "block",
                                flexDirection:
                                  ltrTheme.direction === "rtl"
                                    ? "row-reverse"
                                    : "row",
                                height: isMobile
                                  ? "40px"
                                  : isTabletOrMobile && "40px",
                                alignItems:
                                  ltrTheme.direction === "rtl" &&
                                  isMobile &&
                                  "flex-end",
                              },
                            }}
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: "100%",
                                height: 36,
                                position: "relative",
                                zIndex: 2,
                                direction: "rtl",
                              }),
                            }}
                            sx={{
                              direction: "ltr",
                              "& fieldset": {
                                direction:
                                  ltrTheme.direction === "rtl" ? "ltr" : "ltr",
                              },
                              "& muirtl-ffxztx-container": {
                                direction:
                                  ltrTheme.direction === "rtl" ? "rtl" : "ltr",
                              },
                            }}
                            // />
                          />{" "}
                          <div style={{ height: "30px" }}></div>
                          {/* old - before calendar */}{" "}
                          <Select
                            options={deliveryOptions}
                            width={300}
                            placeholder={t("DETAILS_OF_PACKAGE_DDLINE")}
                            defaultValue={deliveryOptions[0].label}
                            onChange={changeListDelivery}
                            type="select-pickup"
                            styles={{
                              container: (provided) => ({
                                //...provided,
                                width: "100%",
                                height: 36,
                                position: "relative",
                                zIndex: 1,
                                direction: "rtl",
                              }),
                            }}
                          />{" "}
                        </CacheProvider>{" "}
                      </div>
                    ) : (
                      <div
                        className="flex_date_time"
                        style={{
                          visibility: !isTabletOrMobile ? "visible" : "hidden",
                          display: isTabletOrMobile ? "block" : "flex",
                          marginTop: isMobile
                            ? "60px"
                            : isTabletOrMobile
                            ? "0px"
                            : "60px",
                          marginBottom: isMobile
                            ? "45px"
                            : isTabletOrMobile
                            ? "0px"
                            : "65px",
                        }}
                      >
                        <CacheProvider
                          value={
                            // old - before calendar
                            ltrTheme.direction === "rtl" ? cacheRtl : cacheLtr
                          }
                        >
                          <CssBaseline /> {/* old - before calendar */}{" "}
                          <Select
                            options={pickUpOptions}
                            width={300}
                            placeholder={t("DETAILS_OF_PACKAGE_INPUT_DATE")}
                            defaultValue={pickUpOptions[0].label}
                            onChange={changeListPickUp}
                            inputProps={{
                              style: {
                                textAlign:
                                  ltrTheme.direction === "rtl"
                                    ? "right"
                                    : "left",
                                display:
                                  ltrTheme.direction === "rtl"
                                    ? "flex"
                                    : "block",
                                flexDirection:
                                  ltrTheme.direction === "rtl"
                                    ? "row-reverse"
                                    : "row",
                                height: isMobile
                                  ? "40px"
                                  : isTabletOrMobile && "40px",
                                alignItems:
                                  ltrTheme.direction === "rtl" &&
                                  isMobile &&
                                  "flex-end",
                              },
                            }}
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                width: 240,
                                height: 36,
                                direction: "rtl",
                              }),
                              control: (base, state) => ({
                                ...base,
                              }),
                            }}
                            sx={{
                              "& fieldset": {
                                direction:
                                  ltrTheme.direction === "rtl" ? "ltr" : "ltr",
                              },
                              "& .muirtl-ffxztx-container": {
                                direction: "rtl",
                              },
                            }}
                          />{" "}
                          {/* old - before calendar */}
                          <Select
                            options={deliveryOptions}
                            width={300}
                            //height={150}
                            placeholder={t("DETAILS_OF_PACKAGE_DDLINE")}
                            //placeholder={deliveryOptions[0].label}
                            defaultValue={deliveryOptions[0].label}
                            onChange={changeListDelivery}
                            textFieldProps={{
                              label: "Label",
                              InputLabelProps: {
                                shrink: true,
                              },
                            }}
                            styles={{
                              // menu: (provided, state) => ({
                              //   // ...provided,
                              //   // width: state.selectProps.width,
                              //   borderBottom: "1px dotted pink",
                              // }),
                              container: (provided) => ({
                                ...provided,
                                width: 240,
                                height: 36,
                                direction: "rtl",
                              }),
                            }}
                          />{" "}
                        </CacheProvider>{" "}
                      </div>
                    )}{" "}
                    <Button
                      onClick={startSteps}
                      className="marginBtn"
                      style={{
                        height: "62px",
                        margin: "auto",
                        backgroundColor: "#583DFF",
                        borderRadius: "4px",
                      }}
                      variant="contained"
                    >
                      {" "}
                      <img className="Arrow" src={Arrow} alt="Arrow" />{" "}
                      {t("DETAILS_OF_PACKAGE_CONTINUE")}{" "}
                    </Button>{" "}
                  </Stack>{" "}
                </div>{" "}
                <div
                  style={{
                    margin: "auto",
                    fontsize: "11px",
                    width: "100%",
                    height: "60px",
                    //background: "#f2f1f3",
                    float: "right",
                    padding: "5px",
                    textalign: "center",
                    fontweight: "600",
                    direction: "rtl",
                    textAlign: "center",
                    // marginTop: "10px",
                    marginTop: isMobile ? "80px" : "10px",
                  }}
                >
                  <a
                    style={{
                      fontSize: "11px",
                      textDecoration: "none",
                      color: "black",
                    }}
                    href="https://connect.getpogo.app/"
                  >
                    פוגו חיבורים
                  </a>
                  <span style={{ fontSize: "11px" }}>! במקום&nbsp;</span>
                  <a
                    style={{
                      fontSize: "11px",
                      textDecoration: "none",
                      color: "black",
                    }}
                    href="https://connect.getpogo.app/"
                  >
                    חברת שליחויות&nbsp;
                  </a>
                  <span style={{ fontSize: "11px" }}> קבל&nbsp;</span>
                  <a
                    style={{
                      fontSize: "11px",
                      textDecoration: "none",
                      color: "black",
                    }}
                    href="https://connect.getpogo.app/"
                  >
                    <span style={{ fontSize: "11px" }}>משלוח מהיר וזול</span>
                  </a>
                  <span style={{ fontSize: "11px" }}> . בחיבור ישיר ל</span>
                  <a
                    style={{
                      fontSize: "11px",
                      textDecoration: "none",
                      color: "black",
                    }}
                    href="https://connect.getpogo.app/"
                  >
                    מאגר שליחים{" "}
                  </a>
                  <span style={{ fontSize: "11px" }}>
                    הגדול בישראל! אלפי שליחים שמתכננים את מסלול הנסיעה עם
                    אפליקציית&nbsp; פוגו תכנון מסלול&nbsp; וחוסכים 20% זמן ודלק
                  </span>{" "}
                </div>
              </div>{" "}
            </div>
          ) : (
            <div
              className="details MultiSteps"
              style={{ height: isMobile && activeStep == 5 && "700px" }}
            >
              <MultiSteps />
            </div>
          )}
        </div>{" "}
      </div>{" "}
    </section>
  );
}
